var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "customerService"
    }
  }, [_c("a-card", {
    staticClass: "content",
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.add();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.add")) + " ")])], 1)], 1), _c("a-table", {
    attrs: {
      rowKey: "serviceId",
      loading: _vm.isTableLoading,
      "data-source": _vm.customerServiceList,
      pagination: false
    }
  }, [_c("a-table-column", {
    attrs: {
      title: _vm.$t("basicSettings.icon"),
      "data-index": "serviceIcon",
      width: "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [text ? _c("img", {
          staticStyle: {
            height: "30px",
            width: "30px"
          },
          attrs: {
            src: _vm.imageHost + text
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(record.serviceContent) + " ")];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("basicSettings.type"),
      "data-index": "serviceType",
      width: "10%",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [text == 0 ? [_vm._v(_vm._s(_vm.$t("basicSettings.phone")))] : _vm._e(), text == 1 ? [_vm._v(_vm._s(_vm.$t("basicSettings.WeChat")))] : _vm._e(), text == 2 ? [_vm._v(_vm._s(_vm.$t("basicSettings.other")))] : _vm._e()];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      ellipsis: "true",
      "data-index": "serviceTitle",
      width: "10%",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(text))])], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.title")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      ellipsis: "true",
      "data-index": "serviceDescription",
      width: "20%",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(text))])], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.description")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      ellipsis: "true",
      "data-index": "serviceUrl",
      width: "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record, index) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(text))]), text == "" ? _c("span", [_vm._v("-")]) : _vm._e()], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.link")) + " ")])]), _c("a-table-column", {
    attrs: {
      title: _vm.$t("public.operation"),
      align: "left",
      width: "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a", {
          on: {
            click: function click($event) {
              return _vm.edit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("public.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.onDelete(record.serviceId);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.delete")))])])];
      }
    }])
  })], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      width: "1007px",
      centered: true,
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.datavalue,
      rules: _vm.rules
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("a-col", {
    attrs: {
      sm: 8
    }
  }, [_vm.dialogStatus == "update" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.type"),
      prop: "serviceType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: "",
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    model: {
      value: _vm.datavalue.serviceType,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceType", $$v);
      },
      expression: "datavalue.serviceType"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.dialogStatus == "create" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.type"),
      prop: "serviceType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect"),
      allowClear: ""
    },
    on: {
      change: function change($event) {
        return _vm.typeChange(_vm.datavalue.serviceType);
      }
    },
    model: {
      value: _vm.datavalue.serviceType,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceType", $$v);
      },
      expression: "datavalue.serviceType"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e()], 1)], 1), _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_vm._l(_vm.datavalue.titleDescriptionList, function (tempObj, index) {
    return [tempObj.required ? _c("a-col", {
      attrs: {
        sm: 8
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleLable,
        prop: "titleDescriptionList." + index + ".serviceTitle",
        rules: [{
          required: true,
          message: _vm.errTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50
      },
      model: {
        value: tempObj.serviceTitle,
        callback: function callback($$v) {
          _vm.$set(tempObj, "serviceTitle", $$v);
        },
        expression: "tempObj.serviceTitle"
      }
    })], 1)], 1) : _c("a-col", {
      attrs: {
        sm: 8
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleLable
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50
      },
      model: {
        value: tempObj.serviceTitle,
        callback: function callback($$v) {
          _vm.$set(tempObj, "serviceTitle", $$v);
        },
        expression: "tempObj.serviceTitle"
      }
    })], 1)], 1)];
  })], 2), _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_vm._l(_vm.datavalue.titleDescriptionList, function (tempObj, index) {
    return [tempObj.required ? _c("a-col", {
      attrs: {
        sm: 8
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: tempObj.descriptionLable,
        prop: "titleDescriptionList." + index + ".serviceDescription",
        rules: [{
          required: true,
          message: _vm.errTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50
      },
      model: {
        value: tempObj.serviceDescription,
        callback: function callback($$v) {
          _vm.$set(tempObj, "serviceDescription", $$v);
        },
        expression: "tempObj.serviceDescription"
      }
    })], 1)], 1) : _c("a-col", {
      attrs: {
        sm: 8
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: tempObj.descriptionLable
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 50
      },
      model: {
        value: tempObj.serviceDescription,
        callback: function callback($$v) {
          _vm.$set(tempObj, "serviceDescription", $$v);
        },
        expression: "tempObj.serviceDescription"
      }
    })], 1)], 1)];
  })], 2), _vm.datavalue.serviceType == 0 ? _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("a-col", {
    attrs: {
      sm: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.phone"),
      prop: "serviceContent"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 50
    },
    model: {
      value: _vm.datavalue.serviceContent,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceContent", $$v);
      },
      expression: "datavalue.serviceContent"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.datavalue.serviceType == 1 ? _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("a-col", {
    attrs: {
      sm: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.qc-play"),
      prop: "serviceContent"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 50
    },
    model: {
      value: _vm.datavalue.serviceContent,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceContent", $$v);
      },
      expression: "datavalue.serviceContent"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.datavalue.serviceType == 1 ? _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("a-col", {
    attrs: {
      sm: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.link"),
      prop: "serviceUrl"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 255
    },
    model: {
      value: _vm.datavalue.serviceUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceUrl", $$v);
      },
      expression: "datavalue.serviceUrl"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.datavalue.serviceType == 2 ? _c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_c("a-col", {
    attrs: {
      sm: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.link")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      maxLength: 255
    },
    model: {
      value: _vm.datavalue.serviceUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.datavalue, "serviceUrl", $$v);
      },
      expression: "datavalue.serviceUrl"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("publicuse.icon")
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      name: "file",
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      data: _vm.updateData,
      "before-upload": _vm.beforeUpload
    },
    on: {
      change: _vm.handleChangeIcon
    }
  }, [_vm.datavalue.serviceIcon ? _c("img", {
    staticStyle: {
      width: "128px",
      height: "128px"
    },
    attrs: {
      src: _vm.imageHost + _vm.datavalue.serviceIcon,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loadingIcon ? "loading" : "plus"
    }
  })], 1)]), _c("div", {
    staticStyle: {
      color: "#f5222f",
      "line-height": "normal"
    }
  }, [_vm._v(_vm._s(_vm.$t("basicSettings.tipsForUploadingPicture", {
    size: "60*60",
    uploadLimit: _vm.uploadLimit
  })))])], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _vm.dialogStatus == "create" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.confirm")) + " ")]) : _vm._e(), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.update();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.confirm")) + " ")]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };